module.exports = __webpack_public_path__ + "static/ulf_contact-648609a58f124095002e32a71e44f31a.jpg";